import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

function FinderGrid({
  steps,
  currentStep,
  isSelected,
  toggleOption,
  SquareCheck,
  setCurrentStep,
  getNextStepData
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async (label, key, key_filter) => {
    // toggle selection
    toggleOption(currentStep, label, key, key_filter);

    if (currentStep === 0) {
      setLoading(true);

      try {
        // Call the same function as the "Next" button
        // This may include API fetching or data prep
        await getNextStepData?.();

        // Move to next step
        setCurrentStep((prev) => prev + 1);
      } catch (error) {
        console.error("Error advancing step:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div
      className={`finder-grid ${
        steps[currentStep]?.title === "Which Size or Shape fits your Space?"
          ? "finder-grid-full"
          : ""
      }`}
    >
      {steps[currentStep]?.options.map(({ label, image, key, key_filter }) => (
        <div
          key={label}
          className={`finder-card ${
            isSelected(currentStep, label) ? "selected" : ""
          } ${
            steps[currentStep]?.title ===
            "Which Size or Shape fits your Space?"
              ? "big-card"
              : "small-card"
          } ${loading ? "disabled" : ""}`}
          onClick={() => !loading && handleClick(label, key, key_filter)}
        >
          {image && <img loading="lazy" src={image} alt={label} />}
          <span className="card-label">{label}</span>

          {isSelected(currentStep, label) && currentStep !== 0 && (
            <div className="checkmark">
              <SquareCheck size={22} color="#657567" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default FinderGrid;